import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../../service/api/api.service';
import { CommonModule } from '@angular/common';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InscriptionEtapeComponent } from '../../accueil/inscription-etape.component';

@Component({
    selector: 'app-list-login',
    standalone: true, // Composant autonome
    imports: [CommonModule, ReactiveFormsModule],
    templateUrl: './list-login.component.html',
    styleUrls: ['./list-login.component.scss']
})
export class ListLoginComponent implements OnInit, OnDestroy {
    reactiveForm_login_login !: FormGroup;
    submitted: boolean = false
    loading_login_login: boolean = false
    showPassword: boolean = false;

    constructor(private formBuilder: FormBuilder, public api: ApiService, private router: Router , public ActivalModal : NgbActiveModal, private modalService: NgbModal) { }

    ngOnInit(): void {
        console.groupCollapsed("ListLoginComponent");
        this.init_form()
    }
    ngOnDestroy(): void {
        console.groupEnd();
    }
    init_form() {
        this.reactiveForm_login_login = this.formBuilder.group({
            login: ["", Validators.required],
            pwd: ["", Validators.required]
        });
    }

    togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    // acces facile au champs de votre formulaire
    get f(): any { return this.reactiveForm_login_login.controls; }
    // validation du formulaire
    onSubmit_login_login() {
        this.submitted = true;
        // console.log(this.reactiveForm_login_login.value)
        // stop here if form is invalid
        if (this.reactiveForm_login_login.invalid) {
            return;
        }
        var login = this.reactiveForm_login_login.value
        this.login_login(login)
    }
    // vider le formulaire
    onReset_login_login() {
        this.submitted = false;
        this.reactiveForm_login_login.reset();
        this.showPassword = false;
    }
    login_login(login: any) {
        this.loading_login_login = true;
        this.api.taf_post_login("taf_auth/auth", login, async (reponse: any) => {
            if (reponse.status) {
                // console.log("Opération effectuée avec succés sur la table login. Réponse= ", reponse);
                this.onReset_login_login()
                this.ActivalModal.close(reponse);
            } else {
                console.log("L'opération sur la table login a échoué. Réponse= ", reponse);
                this.api.Swal_error("L'opération a echoué")
            }
            this.loading_login_login = false;
        }, (error: any) => {
            this.loading_login_login = false;
        })
    }
     //  Popup inscription
      openInscription(event?: Event) {
        event?.preventDefault();

        this.modalService.open(InscriptionEtapeComponent, {
          centered: true,
          scrollable: true,
          size: 'lg',
          backdrop: 'static'
        });
      }
}
